import React from 'react';
import { Flex, Text } from '@radix-ui/themes';
import TemplateBuilder from './TemplateBuilder';

interface NodeInputProps {
  title: string;
  children: React.ReactNode;
}

export const NodeInput = ({ title, children }: NodeInputProps) => (
  <Flex direction="column" gap="1">
    <Text size="1" color="gray" weight="bold">
      {title}
    </Text>
    {children}
  </Flex>
);

export { TemplateBuilder };
